<template>
  <b-container>
    <LoadingIndicator 
      v-if="loading"
      topic="Project"
    />
    <div v-else-if="project != null">
      <b-row class="text-left" >
        <b-col>
        </b-col>  
        <b-col cols="10" class="mb-3 mt-3">
          <h3>{{project.projectName}}</h3>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row>
        <b-col></b-col>
        <b-col cols="10">
          <ProjectActionBar
            :projectId="project.projectId"
            :surveyId="project.survey ? project.survey.surveyId : ''"
            :status="project.status">
          </ProjectActionBar>
          <b-row class="mt-2">
            <b-col cols="auto" style="width: 600px;">
              <EditProjectForm
                :project="project"
                @submit="projectUpdated"
                @reset="projectUpdated">
              </EditProjectForm>
            </b-col>
          </b-row>
        </b-col>
        <b-col></b-col>
      </b-row>
    </div>
  </b-container>
</template>
<script>
import axios from "axios";
import EditProjectForm from "@/form-components/EditProjectForm.vue";
import ProjectActionBar from "@/sub-components/ProjectActionBar.vue";

export default {
  name: "Project",
  components: {
    EditProjectForm,
    ProjectActionBar
  },
  data() {
    return {
      errors: [],
      loading: false,
      project: null,
      visibility: {
        project: true,
        projectMetrics: false
      }
    }
  },
  mounted() {
    if (!this.isSystemAdmin) {
      this.defaultRedirect();
    }
    let id = this.$route.params.id;
    if (!id) {
      this.$router.push( {
        name: 'Home'
      });
    }
    this.loadProject(id);
  },
  methods: {
    loadProject(projectId) {
      this.loading = true;
      axios
        .get(`${this.$api_url}/projects/${projectId}`, this.getReqConfig())
        .then(response => {
          this.project = response.data;
        })
        .catch(err => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.loading = false;
        })
    },
    projectUpdated(){
      this.$router.go();
    },

  },
  computed: {

  }
}
</script>